import React, { type FC } from 'react'
import { type IntlFormatters, useIntl } from 'react-intl'

import { useRecoilCallback } from 'recoil'

import {
  BADGE_KIND_SECONDARY,
  BADGE_TYPE_DEFAULT,
  BADGE_TYPE_ERROR,
  BADGE_TYPE_SUCCESS,
  BADGE_TYPE_WARNING,
  Badge,
} from 'mailup-web-components'

import { evalCondition } from 'mailup-react-helpers'

import { panelEditRecipientOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

interface ItemStatusProps {
  id: number
  status: any
  isMainItem?: boolean
}

const getBadgeStatus = (
  status: 'SUBSCRIBED' | 'PENDING' | 'UNSUBSCRIBED' | undefined,
): string => {
  switch (status) {
    case 'SUBSCRIBED':
      return BADGE_TYPE_SUCCESS
    case 'PENDING':
      return BADGE_TYPE_WARNING
    case 'UNSUBSCRIBED':
      return BADGE_TYPE_ERROR
    default:
      return BADGE_TYPE_DEFAULT
  }
}

const getBadgeText = (
  intl: IntlFormatters,
  status: 'SUBSCRIBED' | 'PENDING' | 'UNSUBSCRIBED' | undefined,
): string => {
  switch (status) {
    case 'SUBSCRIBED':
      return intl.formatMessage({
        id: 'Load.Common.StatusRecipientSubscribedSingular',
      })
    case 'PENDING':
      return intl.formatMessage({
        id: 'Load.Common.StatusRecipientPendingSingular',
      })
    case 'UNSUBSCRIBED':
      return intl.formatMessage({
        id: 'Load.Common.StatusRecipientUnsibscribedSingular',
      })
    default:
      return intl.formatMessage({
        id: 'Load.Common.StatusRecipientNotSubscribedSingular',
      })
  }
}

const ItemStatus: FC<ItemStatusProps> = ({ id, status, isMainItem }) => {
  const intl = useIntl()

  const panelOpen = useRecoilCallback(panelEditRecipientOpenCallback, [])

  const canEdit = evalCondition('uo:EDIT') as boolean

  const handleClick = (e: React.MouseEvent<HTMLLinkElement>): void => {
    e.stopPropagation()

    void panelOpen(id)
  }
  return (
    <Badge
      kind={BADGE_KIND_SECONDARY}
      type={getBadgeStatus(status)}
      text={getBadgeText(intl, status)}
      onClick={isMainItem === true && canEdit ? handleClick : undefined}
    />
  )
}

export default ItemStatus
